var _defs, _circle, _g, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerPortrait4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2-4",
    gradientTransform: "matrix(0 0 0 0 -123.69 -377.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f4b41",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4-6",
    gradientTransform: "matrix(0 0 0 0 -114.97 -519.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e7867",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1005",
    x1: 54.811,
    x2: 91.853,
    y1: 32.815,
    y2: 32.815,
    gradientTransform: "translate(101.78 121.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3a995",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6-2",
    x1: 18.738,
    x2: 34.255,
    y1: 89.937,
    y2: 89.937,
    gradientTransform: "matrix(.93749 0 0 1.0667 150.25 46.365)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a19a86",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3-6",
    gradientTransform: "matrix(0 0 0 0 162.57 -367.45)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#615b4c",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4011",
    x1: 16.406,
    x2: 19.5,
    y1: 102.63,
    y2: 102.63,
    gradientTransform: "translate(150.25 46.365)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#4-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4013",
    x1: 22.847,
    x2: 28.448,
    y1: 113.27,
    y2: 113.27,
    gradientTransform: "scale(1.1074 .90301)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4015",
    x1: 14.361,
    x2: 15.297,
    y1: 175.31,
    y2: 175.31,
    gradientTransform: "scale(1.677 .59632)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4017",
    x1: 16.463,
    x2: 22.065,
    y1: 113.27,
    y2: 113.27,
    gradientTransform: "scale(1.1074 .90301)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#3-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4019",
    x1: 45.644,
    x2: 83.443,
    y1: 533.01,
    y2: 533.01,
    gradientTransform: "matrix(.38485 0 0 .1819 150.25 46.365)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#4-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4021",
    x1: 2.7435,
    x2: 7.0209,
    y1: 509.65,
    y2: 509.65,
    gradientTransform: "matrix(5.127 0 0 .19505 150.25 46.365)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4023",
    x1: 11.501,
    x2: 20.133,
    y1: 147.82,
    y2: 147.82,
    gradientTransform: "matrix(1.5644 0 0 .63921 150.25 46.365)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4025",
    x1: 9.938,
    x2: 28.948,
    y1: 142.76,
    y2: 142.76,
    gradientTransform: "matrix(1.2776 0 0 .78274 150.25 46.365)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4027",
    x1: 70.561,
    x2: 78.409,
    y1: 108.55,
    y2: 108.55,
    gradientTransform: "matrix(.94563 0 1.7979e-8 1.0575 167.05 49.316)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4029",
    x1: 18.129,
    x2: 25.976,
    y1: 108.55,
    y2: 108.55,
    gradientTransform: "matrix(.94563 0 1.7979e-8 1.0575 -133.45 49.316)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4031",
    x1: 14.638,
    x2: 19.259,
    y1: 99.266,
    y2: 99.266,
    gradientTransform: "translate(150.25 46.365)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#4-6"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156.59 -135.95)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.9,
    height: 279.4,
    fill: "#fcfcfc",
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156.59 -135.95)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.59,
    y: 135.95,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "url(#linearGradient1005)",
    style: {
      paintOrder: "normal"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168.2,
    cy: 150.54,
    r: 1.547,
    fill: "url(#linearGradient4011)",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.82,
    y: 142.3,
    width: 14.547,
    height: 16.552,
    ry: 7.2734,
    fill: "url(#6-2)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.56,
    cy: 151.13,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.24 46.365)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.573,
    y: 102.56,
    width: 5.6591,
    height: 4.5142,
    ry: 2.2571,
    stopColor: "#000000",
    stroke: "url(#linearGradient4013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.355 104.83 1.0246-0.0138",
    stopColor: "#000000",
    stroke: "url(#linearGradient4015)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.504,
    y: 102.56,
    width: 5.6591,
    height: 4.5142,
    ry: 2.2571,
    stopColor: "#000000",
    stroke: "url(#linearGradient4017)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m171.36 143.32c-1.0757 0.64036-1.9693 1.5506-2.5911 2.6386l-0.95653 4.237 11.728-3.6504 2.819 3.5729v-0.54571c0-1.7989-0.64756-3.4402-1.7219-4.7072l-2.0764-1.0222z",
    fill: "url(#linearGradient4019)",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.56,
    cy: 151.13,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.62,
    cy: 151.13,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.62,
    cy: 151.13,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.43,
    y: 155.82,
    width: 7.4291,
    height: 3.1385,
    fill: "#615b4c",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 3.7294,
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 164.32,
    y: 145.77,
    width: 21.93,
    height: 0.83429,
    ry: 0,
    fill: "url(#linearGradient4021)",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 5.1584,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.32 140.85h11.38c0.18387 0 0.30422 0.13838 0.33192 0.32568l0.70847 4.7894c0.0326 0.22009-0.16588 0.40232-0.37194 0.40232h-12.753c-0.20607 0-0.4061-0.18252-0.37196-0.40232l0.74391-4.7894c0.0281-0.18135 0.14802-0.32568 0.33192-0.32568z",
    fill: "url(#linearGradient4023)",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 4.9372,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.12 158.11a12.143 13.298 0 0 0-6.0999 1.7814 12.143 13.298 0 0 0-6.0715 11.516v1.5822h24.287v-1.5822a12.143 13.298 0 0 0-6.0715-11.516 12.143 13.298 0 0 0-6.0441-1.7814z",
    fill: "url(#linearGradient4025)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 -.34068 .94018 0 0)",
    x: 233.78,
    y: 164.1,
    width: 7.4209,
    height: 8.2988,
    ry: 0,
    fill: "url(#linearGradient4027)",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 6.7908,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 .34068 .94018 0 0)",
    x: -116.31,
    y: 164.1,
    width: 7.4209,
    height: 8.2988,
    ry: 0,
    fill: "url(#linearGradient4029)",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 6.7908,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.2,
    cy: 147.94,
    r: 2.3106,
    fill: "url(#linearGradient4031)",
    stopColor: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait4);
export default __webpack_public_path__ + "static/media/player-portrait-4.9cfff0f2723dd7d0b87b132d154e5eda.svg";
export { ForwardRef as ReactComponent };